import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Why from './Why';
import ClientProvider from './client';
export default createDemo(import.meta.url, Why, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/getting-started/usage/demos/why/Why.tsx",
    "fileName": "Why.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import TrendingUpIcon from '@mui/icons-material/TrendingUp';\nimport Box from '@mui/system/Box';\n\nexport default function Why() {\n  return (\n    <Box\n      sx={{\n        p: 2,\n        minWidth: 300,\n        border: '1px solid',\n        borderColor: 'divider',\n        bgcolor: 'background.default',\n        borderRadius: 2,\n      }}\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box sx={{ color: 'text.secondary' }}>Sessions</Box>\n      <Box\n        sx={{ color: 'text.primary', fontSize: '2.125rem', fontWeight: 'medium' }}\n      >\n        98.3 K\n      </Box>\n      <Box\n        component={TrendingUpIcon}\n        sx={{ color: 'success.dark', fontSize: '1rem', verticalAlign: 'sub' }}\n      />\n      <Box\n        sx={{\n          display: 'inline',\n          fontSize: '0.875rem',\n          fontWeight: 'bold',\n          color: 'success.dark',\n          mx: 0.5,\n        }}\n      >\n        18.7%\n      </Box>\n      <Box sx={{ color: 'text.secondary', display: 'inline', fontSize: '0.875rem' }}>\n        vs. last week\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 42,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import TrendingUpIcon from '@mui/icons-material/TrendingUp';\nimport Box from '@mui/system/Box';\n\nexport default function Why() {\n  return (\n    <Box\n      sx={{\n        p: 2,\n        minWidth: 300,\n        border: '1px solid',\n        borderColor: 'divider',\n        bgcolor: 'background.default',\n        borderRadius: 2,\n      }}\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Box sx={{ color: 'text.secondary' }}>Sessions</Box>\n      <Box\n        sx={{ color: 'text.primary', fontSize: '2.125rem', fontWeight: 'medium' }}\n      >\n        98.3 K\n      </Box>\n      <Box\n        component={TrendingUpIcon}\n        sx={{ color: 'success.dark', fontSize: '1rem', verticalAlign: 'sub' }}\n      />\n      <Box\n        sx={{\n          display: 'inline',\n          fontSize: '0.875rem',\n          fontWeight: 'bold',\n          color: 'success.dark',\n          mx: 0.5,\n        }}\n      >\n        18.7%\n      </Box>\n      <Box sx={{ color: 'text.secondary', display: 'inline', fontSize: '0.875rem' }}>\n        vs. last week\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 42,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/icons-material/TrendingUp",
      "@mui/system/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
